import { render, staticRenderFns } from "./ListaCreditos.vue?vue&type=template&id=cfe3857c"
import script from "./ListaCreditos.vue?vue&type=script&lang=js"
export * from "./ListaCreditos.vue?vue&type=script&lang=js"
import style0 from "./ListaCreditos.vue?vue&type=style&index=0&id=cfe3857c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VTextField})
